import { setAlert } from './alert';

import { USERS_ERROR, GET_USER, GET_USERS, UPDATE_USER_STATUS } from './types';
import URL from './url';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

// Change user status
export const changeStatus = (status, id) => async dispatch => {
  try {
    const res = await URL.patch(`/api/users/empresas/status/${id}`, { status }, config);
    dispatch({
      type: UPDATE_USER_STATUS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: USERS_ERROR,
      payload: errors
    });
  }
}

/***************RECUPERAR CONTRASEÑA******************/

//verify user (2026)
export const checkUser = async dato => {
  try {
    const res = await URL.get(`/api/users/telemail/${dato}`,);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      return errors;
    }
  }
}

//obtener código (2026)
export const getCode = async (emailTel, data, subject = "validar") => {
  try {
    if (emailTel === "celular") {
      const res = await URL.get(`/api/users/phone?phonenumber=${data.tel}&channel=sms&forgotpass=true`);
      return res.data;
    } else {
      data.subject = subject;
      const res = await URL.post(`/api/users/send/email`, data);
      return res.data;
    }

  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      return errors;
    }
  }
}

//Verificar código (2026)
export const checkCode = async (formData, addUser = false) => {
  try {
    let url = `/api/users/verify?code=${formData.code}`;

    if (formData.email) {
      url += `&email=${formData.email}&type=email`;
    } else {
      url += `&phonenumber=+${formData.phonenumber}`;
    }

    const res = await URL.get(url);
    if (addUser) {
      return res.data
    }
    if (res.data.status === 'approved' && res.data.valid === true) {
      return true
    }
    return false;
  } catch (err) {
    return err.response.data;
  }
}

//Send Code verify(SMS) (2026)
export const sendCode = infoUser => async dispatch => {
  try {
    const res = await URL.get(`/api/users/phone?phonenumber=${infoUser.num}&channel=sms`);
    return res;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg)));
    }
  }
}

//Send Code verify(Email) (2026)
export const sendCodeEmail = data => async dispatch => {
  try {
    const res = await URL.post(`/api/users/send/email`, data);
    return res;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg)));
    }
  }
}

export const sendRejectionEmail = (data) => async dispatch => {
  try {
    const res = await URL.post(`/api/users/send/email/rechazo`, data);
    return res;

  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg)));
    }
    dispatch({
      type: USERS_ERROR
    });
  }
}

// change password (2026)
export const changePassForgot = async (formData, id) => {
  try {
    await URL.patch(`/api/users/pass/forgot/${id}`, formData, config);
    return true
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      return errors;
    }
  }
}

/***************FIN DE RECUPERAR CONTRASEÑA***************/

/****************REGISTRO****************/

//verify email (2026)
export const checkEmail = async email => {
  try {
    await URL.get(`/api/users/email/${email}`);
    return true;
  } catch (err) {
    const errors = err.response.data.errors;
    console.log(err, "Errores en checkEmail");
    return errors;
  }
}

// Add user (2026)
export const addUser = (formData, history) => async dispatch => {
  try {
    await URL.post(`/api/users`, formData, config);
    history('/signup-last', {
      state: {
        status: 'success'
      }
    });
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg)));
    }
  }
}

// Get user without dipatch (2026)
export const getUserbyId = async id => {
  try {
    const res = await URL.get(`/api/users/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

// Get user without dipatch
export const getUser = id => async dispatch => {
  try {
    const res = await URL.get(`/api/users/${id}`);
    dispatch({
      type: GET_USER,
      payload: res.data
    })
  } catch (err) {
    console.error(err);
  }
}

// Get todos los usuarios que tengan datos_empresas
export const getUsers = () => async dispatch => {
  try {
    const res = await URL.get(`/api/users/admin/all`);
    dispatch({
      type: GET_USERS,
      payload: res.data
    })
  } catch (err) {
    console.error(err);
  }
}

// Add user datos fiscales
export const addFiscales = (formData, id) => async dispatch => {
  try {
    const res = await URL.patch(`/api/users/sat/${id}`, formData, config);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: USERS_ERROR,
      payload: errors
    });
  }
}


// Add user datos fiscales
export const editFiscales = (formData, id) => async dispatch => {
  try {
    const res = await URL.patch(`/api/users/sat/edit/${id}`, formData, config);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: USERS_ERROR,
      payload: errors
    });
  }
}

// Get todos los usuarios que tengan datos_empresas
export const editInversion = (formData, id, idInv) => async dispatch => {
  try {
    const res = await URL.patch(`/api/users/${id}/inversion/${idInv}/edit`, formData, config);
    dispatch(getUsers());
  } catch (err) {
    console.error(err);
  }
}

// Eliminar inversion
export const deleteInversion = (id, idInv) => async dispatch => {
  try {
    await URL.delete(`/api/users/${id}/inversion/${idInv}`, config);
    dispatch(getUsers());
  } catch (err) {
    console.error(err);
  }
}

// Get todos los usuarios que tengan datos_empresas
export const editInversionClient = (formData, id, idInv) => async dispatch => {
  try {
    const res = await URL.patch(`/api/users/${id}/inversion/${idInv}/edit`, formData, config);
    dispatch(getUser(id));
  } catch (err) {
    console.error(err);
  }
}
